import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import RetornoLogin from "./RetornoLogin"
import {gateway} from "../../utils/api"

import {generateSecurePassword} from '../../utils/functions';

class NovaSenha extends PureComponent {
  static contextTypes = {
    router: PropTypes.shape(),
  }

  state = {
    code: "",
    password: "",
    confirmPassword: "",
    error: "",
  }

  novaSenha = async evt => {
    evt.preventDefault()
    const { code, password } = this.state
    const { email } = this.props
    const { router } = this.context

    const changePassword = {
      email,
      code: code.trim(),
      newPasswd: generateSecurePassword(password),
      fromMonolith: false
    }
    try {
      const response = await gateway.post("/webbff/lit_app_web/login/changePassword", changePassword)
      this.notify(response.message, "success")
      router.history.push('/')
    } catch (error) {
      console.log(error)
      this.setState({ error: error.response.data.message })
    }
  }

  notify = (text, type = "success") => {
    toast(text, {
      type,
      closeButton: false,
    })
  }

  validatePassword = () => {
    const { password, confirmPassword } = this.state
    if((password || confirmPassword) && password !== confirmPassword) {
      return false
    }
    return true
  }

  render() {
    const { code, password, confirmPassword, error } = this.state
    return (
      <React.Fragment>
        <form style={{ marginTop: "2em" }} onSubmit={this.novaSenha}>
          <div className="field-float-label-pattern">
            <div>
              <input
                placeholder="Código enviado no email"
                className="form-control input-not-yellow"
                id="inputCode"
                value={code}
                onChange={evt => this.setState({ code: evt.target.value })}
                required
              />
              <label htmlFor="inputCode">Código</label>
            </div>
            <div>
              <input
                type="password"
                placeholder="Nova senha"
                className="form-control input-not-yellow"
                id="inputPassword"
                value={password}
                onChange={evt => this.setState({ password: evt.target.value })}
                required
              />
              <label htmlFor="inputPassword">Nova senha</label>
            </div>
            <div>
              <input
                type="password"
                placeholder="Confirmar nova senha"
                className="form-control input-not-yellow"
                id="inputConfirmPassword"
                value={confirmPassword}
                onChange={evt => this.setState({ confirmPassword: evt.target.value })}
                required
              />
              <label htmlFor="inputConfirmPassword">Nova senha</label>
            </div>
          </div>
          <div className="row">
            <div className="col">
              {error && (<p style={{ color: "#e50000" }}>{error}</p>)}
              {!this.validatePassword() ? (
                <p style={{ color: "#e50000" }}>As senhas não coincidem</p>
              ) : null}
            </div>
          </div>

          <div className="row justify-content-center">
            <button type="submit" className="btn btn-login btn-FontWeight6" disabled={!this.validatePassword()}>
              Redefinir
            </button>
          </div>
        </form>
        <RetornoLogin />
      </React.Fragment>
    )
  }
}

export default NovaSenha
